export const VIDEO_APP_DEF_ID = '14409595-f076-4753-8303-9a86f9f71469';



// WEBPACK FOOTER //
// ./src/shared/constants/app-def-id.js